// src/components/Navbar/navConfig.js

/**
 * Базовая конфигурация ролей и интерфейсов.
 * Используется для отображения карточек на главной странице
 * и проверки прав доступа.
 */

export const navConfig = [
  {
    key: 'admin',
    label: 'Админ',
    permission: 'pages:admin:view:any',
    icon: 'bi-speedometer2',
  },
  {
    key: 'courier',
    label: 'Курьер',
    permission: 'pages:courier:view:any',
    icon: 'bi-truck',
  },
  {
    key: 'logist',
    label: 'Логист',
    permission: 'pages:logist:view:any',
    icon: 'bi-geo-alt',
  },
  {
    key: 'dispatcher',
    label: 'Диспетчер',
    permission: 'pages:dispatcher:view:any',
    icon: 'bi-headphones',
  },
  {
    key: 'manager',
    label: 'Управляющий',
    permission: 'pages:manager:view:any',
    icon: 'bi-briefcase',
  },
  {
    key: 'storekeeper',
    label: 'Кладовщик',
    permission: 'pages:storekeeper:view:any',
    icon: 'bi-box-seam',
  },
  {
    key: 'developer',
    label: 'Разработчик',
    permission: 'pages:developer:view:any',
    icon: 'bi-code-square',
  },
];
